import React, { useEffect, useMemo, useState } from "react";
import "../css/profile.scss";
import axios from "axios";
import Switch from "react-switch";
import { useSelector } from "react-redux";
import {
  DELETE_REFERRALCODE,
  DELETE_SUBSCRIPTION,
  Get_SUbSCRIBEDMAIL,
  POST_CODEVALID,
  POST_USEDCODES,
  Reffral_Get,
  SUBSCRIBE_MAIL,
  delete_User,
  get_backlinktotallmtGet,
  POST_CONVERTKIT,
  GET_AWLIMIT,
  GET_REFDOMAINLIMIT,
} from "../../services/constants";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import AreYousure from "../share/card-layout/AreYousure";
import ToolTip from "../share/components/tooltip";
import SubUserDetails from "../share/components/sub-user.component";
import Avtar from "../share/components/avtar.component";
import { ZustandStore } from "../../store/zustand-store";
import { codevalidupdate } from "../../services/constants";
import Tooltip from "../share/components/tooltip";
import useUserAccountUsage from "../../helperJs/useUserAccountUsage";
import { free_plan, stringToBoolean } from "../../helperJs/helper";
import CancelPlanPopUp from "../share/components/dialog/cancelPlanDialog";
import FallbackLoader from "../share/components/FallbackLoader";
import Spinner from "../share/components/spinner";
import { useBuyAddonHandler } from "../share/custom-hook/useBuyAddonHandler";

import { Delete } from "@mui/icons-material";
import CircleIcon from "@mui/icons-material/Circle";
import noPlanImg from "../Assets/Profile/no_plan.png";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const Profile = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { handleAddonPlan } = useBuyAddonHandler();
  const { plan_loaded, aiLimit, customer_plan } = ZustandStore(
    (state) => state
  );
  const adminMail = localStorage.getItem("admin_mail");
  const user_type = localStorage.getItem("user_type");
  const user_id = localStorage.getItem("user_id");
  const ai_plan = customer_plan?.ai_plan || free_plan;
  const codeValidJsonStringParsedArray = customer_plan?.code || [];
  let pdf_editable = stringToBoolean(customer_plan?.whitelabel) || false;
  const userName = useSelector((state) => state.name);
  const email = useSelector((state) => state.email);
  const subuserinvitelimit = useSelector((state) => state.subuserinvitelimit);
  const competitorslimit = useSelector((state) => state.competitorslimit);
  const keywordviewlimit = useSelector((state) => state.keywordviewlimit);
  const userprojectlimit = useSelector((state) => state.userprojectlimit);
  const userkeywordlimit = useSelector((state) => state.userkeywordlimit);
  const domainviewlimit = useSelector((state) => state.domainviewlimit);
  const backlinklimits = useSelector((state) => state.backlinkLimit);
  const userRowLmt = backlinklimits?.backlinks_rows_limit;
  const [cancelPlan, setCancelPlan] = useState(false);
  const [deleteAlert, setdeleteAlert] = useState(false);
  const [refAlert, setRefAlert] = useState(false);
  const [validReferalCode, setValidReferalCode] = useState({
    referral_code_1: "",
    referral_code_2: "",
    referral_code_3: "",
    referral_code_4: "",
    referral_code_5: "",
    referral_code_6: "",
  });
  const [refftalMatch, setReffralMatch] = useState([]);
  const [backlinkRowLmt, setBacklinkRowLmt] = useState([]);
  const [referralCode, setReferralCode] = useState("");
  const [checkMailSub, setCheckMail_Sub] = useState(false);
  const [refDomain, setRefDomain] = useState(0);
  const { accUsage, loading, error } = useUserAccountUsage();

  const invited_user =
    adminMail?.toLocaleLowerCase() === email.toLocaleLowerCase();
  const fatch_reffralGet = () => {
    if (refftalMatch?.length === 0) {
      axios.get(Reffral_Get()).then((res) => {
        setReffralMatch(res.data.data);
      });
    }
  };

  const Fatch_SUbSCRIBEDMAIL = () =>
    axios.get(Get_SUbSCRIBEDMAIL()).then((res) => {
      const subCheck = res.data.find((user) => user.email === email);
      if (subCheck) {
        setCheckMail_Sub(true);
      } else {
        setCheckMail_Sub(false);
      }
    });

  const getBacklinkLimit = (email) => {
    axios.get(get_backlinktotallmtGet(email)).then((response) => {
      if (response.data.length > 0) {
        setBacklinkRowLmt(
          response.data[response.data?.length - 1].backlinktotallmt
        );
      }
    });
  };

  const handleGetAILimit = () => {
    const reset = {
      id: null,
      email: null,
      limit: 0,
      article: 0,
      meta: 0,
    };

    axios
      .get(GET_AWLIMIT(email))
      .then((response) => {
        const data = response?.data;
        if (data?.length === 0) {
          ZustandStore.setState({
            aiLimit: reset,
          });
        } else {
          ZustandStore.setState({
            aiLimit: data?.[0],
          });
        }
      })
      .catch(() => {
        ZustandStore.setState({
          aiLimit: reset,
        });
      });
  };

  const handleGetRefDomain = () => {
    const config = {
      email: email,
      domain: "",
    };
    axios
      .get(GET_REFDOMAINLIMIT(config))
      .then((response) => {
        setRefDomain(response?.data?.length || 0);
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (plan_loaded) {
      getBacklinkLimit(email);
      fatch_reffralGet();
      Fatch_SUbSCRIBEDMAIL();
      handleGetRefDomain();
      handleGetAILimit();
    }
  }, [plan_loaded]);

  const User_Delete = (res) => {
    if (res) {
      axios.delete(delete_User(user_id)).then(() => {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login");
      });
    } else {
      setdeleteAlert(false);
    }
  };

  const handleConvertKit = () => {
    axios
      .post(POST_CONVERTKIT(), {
        email: email,
      })
      .then(() => {})
      .catch(() => {});
  };

  const ReferalHandler_Submit = (e) => {
    e.preventDefault();

    const foundPlan1 = refftalMatch.find((plan) =>
      plan.codes.includes(validReferalCode?.referral_code_1)
    );
    const foundPlan2 = refftalMatch.find((plan) =>
      plan.codes.includes(validReferalCode?.referral_code_2)
    );
    const foundPlan3 = refftalMatch.find((plan) =>
      plan.codes.includes(validReferalCode?.referral_code_3)
    );
    const foundPlan4 = refftalMatch.find((plan) =>
      plan.codes.includes(validReferalCode?.referral_code_4)
    );
    const foundPlan5 = refftalMatch.find((plan) =>
      plan.codes.includes(validReferalCode?.referral_code_5)
    );
    const foundPlan6 = refftalMatch.find((plan) =>
      plan.codes.includes(validReferalCode?.referral_code_6)
    );

    // we can reset referral codes by using this func .
    const resetReferralCodes = () => {
      setValidReferalCode({
        referral_code_1: "",
        referral_code_2: "",
        referral_code_3: "",
        referral_code_4: "",
        referral_code_5: "",
        referral_code_6: "",
      });
    };

    // this condition stops you , when ever you tring to submit with out filling any referral input .
    if (
      validReferalCode?.referral_code_1 === "" &&
      validReferalCode?.referral_code_2 === "" &&
      validReferalCode?.referral_code_3 === "" &&
      validReferalCode?.referral_code_4 === "" &&
      validReferalCode?.referral_code_5 === "" &&
      validReferalCode?.referral_code_6 === ""
    ) {
      setRefAlert(t("profile.alert_msg.enter_code"));
    } else if (
      (validReferalCode?.referral_code_1 !== "" &&
        (validReferalCode?.referral_code_1 ===
          validReferalCode?.referral_code_2 ||
          validReferalCode?.referral_code_1 ===
            validReferalCode?.referral_code_3 ||
          validReferalCode?.referral_code_1 ===
            validReferalCode?.referral_code_4 ||
          validReferalCode?.referral_code_1 ===
            validReferalCode?.referral_code_5 ||
          validReferalCode?.referral_code_1 ===
            validReferalCode?.referral_code_6)) ||
      (validReferalCode?.referral_code_2 !== "" &&
        (validReferalCode?.referral_code_2 ===
          validReferalCode?.referral_code_3 ||
          validReferalCode?.referral_code_2 ===
            validReferalCode?.referral_code_4 ||
          validReferalCode?.referral_code_2 ===
            validReferalCode?.referral_code_5 ||
          validReferalCode?.referral_code_2 ===
            validReferalCode?.referral_code_6)) ||
      (validReferalCode?.referral_code_3 !== "" &&
        (validReferalCode?.referral_code_3 ===
          validReferalCode?.referral_code_4 ||
          validReferalCode?.referral_code_3 ===
            validReferalCode?.referral_code_5 ||
          validReferalCode?.referral_code_3 ===
            validReferalCode?.referral_code_6)) ||
      (validReferalCode?.referral_code_4 !== "" &&
        (validReferalCode?.referral_code_4 ===
          validReferalCode?.referral_code_5 ||
          validReferalCode?.referral_code_4 ===
            validReferalCode?.referral_code_6)) ||
      (validReferalCode?.referral_code_5 !== "" &&
        validReferalCode?.referral_code_5 === validReferalCode?.referral_code_6)
    ) {
      // same referral code each input box .
      setRefAlert(t("profile.alert_msg.enter_same_code"));
      resetReferralCodes();
    } else if (
      (!foundPlan1 && validReferalCode?.referral_code_1 !== "") ||
      (!foundPlan2 && validReferalCode?.referral_code_2 !== "") ||
      (!foundPlan3 && validReferalCode?.referral_code_3 !== "") ||
      (!foundPlan4 && validReferalCode?.referral_code_4 !== "") ||
      (!foundPlan5 && validReferalCode?.referral_code_5 !== "") ||
      (!foundPlan6 && validReferalCode?.referral_code_6 !== "")
    ) {
      // Non valid codes .
      setRefAlert(t("profile.alert_msg.valid_code"));
      resetReferralCodes();
    } else if (
      (foundPlan1 &&
        foundPlan2 &&
        foundPlan1.validity !== foundPlan2?.validity) ||
      (foundPlan1 &&
        foundPlan3 &&
        foundPlan1.validity !== foundPlan3?.validity) ||
      (foundPlan1 &&
        foundPlan4 &&
        foundPlan1.validity !== foundPlan4?.validity) ||
      (foundPlan1 &&
        foundPlan5 &&
        foundPlan1.validity !== foundPlan5?.validity) ||
      (foundPlan1 &&
        foundPlan6 &&
        foundPlan1.validity !== foundPlan6?.validity) ||
      (foundPlan2 &&
        foundPlan3 &&
        foundPlan2.validity !== foundPlan3?.validity) ||
      (foundPlan2 &&
        foundPlan4 &&
        foundPlan2.validity !== foundPlan4?.validity) ||
      (foundPlan2 &&
        foundPlan5 &&
        foundPlan2.validity !== foundPlan5?.validity) ||
      (foundPlan2 &&
        foundPlan6 &&
        foundPlan2.validity !== foundPlan6?.validity) ||
      (foundPlan3 &&
        foundPlan4 &&
        foundPlan3.validity !== foundPlan4?.validity) ||
      (foundPlan3 &&
        foundPlan5 &&
        foundPlan3.validity !== foundPlan5?.validity) ||
      (foundPlan3 &&
        foundPlan6 &&
        foundPlan3.validity !== foundPlan6?.validity) ||
      (foundPlan4 &&
        foundPlan5 &&
        foundPlan4.validity !== foundPlan5?.validity) ||
      (foundPlan4 &&
        foundPlan6 &&
        foundPlan4.validity !== foundPlan6?.validity) ||
      (foundPlan5 && foundPlan6 && foundPlan5.validity !== foundPlan6?.validity)
    ) {
      // if you using deferrent validity codes .
      setRefAlert(t("profile.alert_msg.diff_validity_code"));
      resetReferralCodes();
    }
    // submit .
    else {
      // select a plan from all found plans .
      const foundPlan =
        foundPlan1 ||
        foundPlan2 ||
        foundPlan3 ||
        foundPlan4 ||
        foundPlan5 ||
        foundPlan6;

      // here we push referral codes which have plan .
      const sendTrue_Codes = codeValidJsonStringParsedArray || [];
      if (foundPlan1) {
        sendTrue_Codes.push(validReferalCode?.referral_code_1);
      }
      if (foundPlan2) {
        sendTrue_Codes.push(validReferalCode?.referral_code_2);
      }
      if (foundPlan3) {
        sendTrue_Codes.push(validReferalCode?.referral_code_3);
      }
      if (foundPlan4) {
        sendTrue_Codes.push(validReferalCode?.referral_code_4);
      }
      if (foundPlan5) {
        sendTrue_Codes.push(validReferalCode?.referral_code_5);
      }
      if (foundPlan6) {
        sendTrue_Codes.push(validReferalCode?.referral_code_6);
      }

      // here we set plan name by the referal codes length .
      const def_codeName =
        sendTrue_Codes?.length === 1
          ? "pro"
          : sendTrue_Codes?.length === 2
          ? "elite"
          : sendTrue_Codes?.length >= 3
          ? "lifetime"
          : foundPlan.plan_name;

      // getting future date for plan expiry .
      const currentDate = new Date();
      const futureDate = new Date();
      futureDate.setDate(currentDate.getDate() + Number(foundPlan.validity));
      const futureDay = futureDate.getDate();

      // here we save all credentials. which have post in to the codeValid API .
      const reffralItems = {
        email: email,
        code_valid: sendTrue_Codes,
        valid: foundPlan.validity,
        code_name: def_codeName,
        expiry_date: foundPlan.validity === "lifetime" ? 100 : futureDay,
      };

      // this code of json using for USEDCODE API .
      const usedCodes_Json = {
        plan_name: reffralItems.code_name,
        codes: reffralItems.code_valid,
        validity: reffralItems.valid,
      };

      const json_DELETE = JSON.stringify(reffralItems.code_valid);

      if (customer_plan?.referral_user) {
        axios
          .put(codevalidupdate(customer_plan?.referral_id), reffralItems)
          .then(() => {
            axios.post(POST_USEDCODES(), usedCodes_Json);
            axios.put(DELETE_REFERRALCODE(json_DELETE)).then(() => {
              // this function reset the data of referal_get variable
              handleConvertKit();
              fatch_reffralGet();
              navigate("/dashboard");
              navigate(0);
            });
          })
          .catch(() => {
            console.log("error on code: plan update");
          });
      } else {
        axios
          .post(POST_CODEVALID(), reffralItems)
          .then(() => {
            setRefAlert("Matched");
            resetReferralCodes();
            axios.post(POST_USEDCODES(), usedCodes_Json);
            axios.put(DELETE_REFERRALCODE(json_DELETE)).then(() => {
              // this function reset the data of referal_get variable
              handleConvertKit();
              fatch_reffralGet();
              navigate("/dashboard");
              navigate(0);
            });
          })
          .catch(() => {
            setRefAlert(t("profile.alert_msg.already_plan"));
          });
        // this code of json using for DELETE CODE API .
      }
    }
  };

  const SubscribeHandler = () => {
    if (checkMailSub) {
      axios.delete(DELETE_SUBSCRIPTION(email)).then(() => {
        Fatch_SUbSCRIBEDMAIL();
      });
    } else {
      const today = new Date();
      var dd = today.getDate();

      const subscribeMail_Json = {
        email: email,
        subscribe: "daily",
        Date: dd,
      };

      axios.post(SUBSCRIBE_MAIL(), subscribeMail_Json).then(() => {
        Fatch_SUbSCRIBEDMAIL();
      });
    }
  };

  const handleChange = (e) => {
    setRefAlert(false);
    const input = e.target.value;
    const newCodesArray = input
      .split(",")
      .map((code) => code.trim())
      .filter((code) => code !== "");
    const uniqueNewCodesArray = Array.from(new Set(newCodesArray));

    // Check for duplicates in the new codes
    if (newCodesArray.length !== uniqueNewCodesArray.length) {
      setRefAlert(t("profile.alert_msg.duplicate_or_used_code"));
      setReferralCode(input);
      return;
    }

    const limit = 6;
    const combinedCodesArray = [
      ...codeValidJsonStringParsedArray,
      ...uniqueNewCodesArray,
    ];
    const combinedCodesSet = new Set(combinedCodesArray);
    if (combinedCodesSet.size !== combinedCodesArray?.length) {
      setRefAlert(t("profile.alert_msg.duplicate_code"));
      setReferralCode(input);
      return;
    }

    if (combinedCodesSet.size <= limit) {
      setReferralCode(input);
      const allCodesArray = Array.from(combinedCodesSet);
      if (codeValidJsonStringParsedArray?.length === 0) {
        setValidReferalCode({
          referral_code_1: allCodesArray[0] || "",
          referral_code_2: allCodesArray[1] || "",
          referral_code_3: allCodesArray[2] || "",
          referral_code_4: allCodesArray[3] || "",
          referral_code_5: allCodesArray[4] || "",
          referral_code_6: allCodesArray[5] || "",
        });
      } else if (codeValidJsonStringParsedArray?.length === 1) {
        setValidReferalCode({
          referral_code_1: "",
          referral_code_2: allCodesArray[1] || "",
          referral_code_3: allCodesArray[2] || "",
          referral_code_4: allCodesArray[3] || "",
          referral_code_5: allCodesArray[4] || "",
          referral_code_6: allCodesArray[5] || "",
        });
      } else if (codeValidJsonStringParsedArray?.length === 2) {
        setValidReferalCode({
          referral_code_1: "",
          referral_code_2: "",
          referral_code_3: allCodesArray[2] || "",
          referral_code_4: allCodesArray[3] || "",
          referral_code_5: allCodesArray[4] || "",
          referral_code_6: allCodesArray[5] || "",
        });
      } else if (codeValidJsonStringParsedArray?.length === 3) {
        setValidReferalCode({
          referral_code_1: "",
          referral_code_2: "",
          referral_code_3: "",
          referral_code_4: allCodesArray[3] || "",
          referral_code_5: allCodesArray[4] || "",
          referral_code_6: allCodesArray[5] || "",
        });
      } else if (codeValidJsonStringParsedArray?.length === 4) {
        setValidReferalCode({
          referral_code_1: "",
          referral_code_2: "",
          referral_code_3: "",
          referral_code_4: "",
          referral_code_5: allCodesArray[4] || "",
          referral_code_6: allCodesArray[5] || "",
        });
      } else if (codeValidJsonStringParsedArray?.length === 5) {
        setValidReferalCode({
          referral_code_1: "",
          referral_code_2: "",
          referral_code_3: "",
          referral_code_4: "",
          referral_code_5: "",
          referral_code_6: allCodesArray[5] || "",
        });
      }
    } else {
      setRefAlert(`You can only enter up to ${limit} referral codes.`);
    }
  };

  const plan_feature = useMemo(() => {
    return [
      `${customer_plan?.proj_len} domains/projects`,
      `${customer_plan?.keyword_len} tracked keywords`,
      `${customer_plan?.competitors_limit} competitors per project`,
      `${customer_plan?.sub_users_limit} users`,
      `${customer_plan?.site_overview_limit} site overview`,
      `${customer_plan?.backlinks_rows_limit} backlinks credits`,
      `${customer_plan?.site_audit_limit} site audit credits weekly`,
      `${customer_plan?.key_limit} keyword research credits`,
    ];
  }, [customer_plan]);

  const userAccountUsage = useMemo(() => {
    const no_plan = customer_plan?.length === 0;
    return [
      {
        label: t("profile.account_usage.projects"),
        value: no_plan
          ? 0
          : `${accUsage?.total_project || 0}/${userprojectlimit}`,
        addon_link: `https://buy.stripe.com/00gcPn0kC9Zg46I00R?prefilled_email=${email}`,
      },
      {
        label: t("profile.account_usage.keywords"),
        value: no_plan
          ? 0
          : `${accUsage?.total_keyword_tracking || 0}/${userkeywordlimit}`,
        addon_link: `https://buy.stripe.com/eVa9DbaZggnEgTu3cY?prefilled_email=${email}`,
      },
      {
        label: "AI Overview Projects",
        value: no_plan
          ? 0
          : `${accUsage?.total_ai_project || 0}/${customer_plan?.aio_project}`,
        addon_link: null,
      },
      {
        label: "AI Overview Keywords",
        value: no_plan
          ? 0
          : `${accUsage?.total_ai_tracking || 0}/${customer_plan.ai_keyword}`,
        addon_link: `https://buy.stripe.com/cNi28rgf06AcdmdcjT0Fi17?prefilled_email=${email}`,
      },
      {
        label: "LLM Projects",
        value: no_plan
          ? 0
          : `${accUsage?.total_llm_project || 0}/${customer_plan.llm_project}`,
        addon_link: null,
      },
      {
        label: "LLM Prompts",
        value: no_plan
          ? 0
          : `${accUsage?.total_llm_keyword_tracking || 0}/${
              customer_plan.llm_keyword
            }`,
        addon_link: null,
      },
      {
        label: t("profile.account_usage.user_limits"),
        value: no_plan ? 0 : subuserinvitelimit,
        addon_link: `https://buy.stripe.com/dR6g1z8R88Vc8mYfZV?prefilled_email=${email}`,
      },
      {
        label: t("profile.account_usage.track_competitor"),
        value: no_plan
          ? 0
          : `${competitorslimit} ${t("profile.account_usage.per_project")}`,
        addon_link: `https://buy.stripe.com/cN216F5EWb3kdHidRM?prefilled_email=${email}`,
      },
      {
        label: t("profile.account_usage.site_audit"),
        value: no_plan
          ? 0
          : `${customer_plan?.site_audit_limit || 0} ${t(
              "profile.account_usage.weekly"
            )}`,
        addon_link: `https://buy.stripe.com/fZe2aJaZg3AS9r2dRK?prefilled_email=${email}`,
      },
      {
        label: t("profile.account_usage.keyword_research"),
        value: no_plan
          ? 0
          : `${accUsage?.total_keyword_limit || 0}/${keywordviewlimit}`,
        addon_link: `https://buy.stripe.com/eVa16F2sK1sK9r25ld?prefilled_email=${email}`,
      },
      {
        label: t("profile.account_usage.competitive_research"),
        value: no_plan
          ? 0
          : `${accUsage?.total_overview_limit || 0}/${domainviewlimit}`,
        addon_link: `https://buy.stripe.com/eVa9Db3wO4EWbzadRL?prefilled_email=${email}`,
      },
      {
        label: t("profile.account_usage.backlinks_row"),
        value: no_plan
          ? 0
          : `${
              backlinkRowLmt?.length === 0
                ? 0
                : backlinkRowLmt < 0
                ? userRowLmt
                : userRowLmt - backlinkRowLmt
            }/${userRowLmt}`,
        addon_link: `https://buy.stripe.com/6oE9DbebsdbscDe4h8?prefilled_email=${email}`,
      },
      {
        label: t("profile.account_usage.ref_domain"),
        value: no_plan ? 0 : `${refDomain || 0}/${customer_plan?.ref_domain}`,
        addon_link: `https://buy.stripe.com/00g7v3c3kb3kcDe157?prefilled_email=${email}`,
      },
      {
        label: "Exact URL",
        value: no_plan
          ? 0
          : `${accUsage.total_url || 0}/${customer_plan?.exact_url}`,
        addon_link: `https://buy.stripe.com/00g4iR1oG6N46eQ155?prefilled_email=${email}`,
      },
      {
        label: t("profile.account_usage.white_label"),
        value: `${
          pdf_editable ? t("profile.ai_writer.yes") : t("profile.ai_writer.no")
        }`,
        addon_link: pdf_editable
          ? false
          : `https://buy.stripe.com/00g8z7aZg7R81YA6po?prefilled_email=${email}`,
      },
      {
        label: "White Label Platform (Reports Included)",
        value: `${
          customer_plan.whitelabel_platform
            ? t("profile.ai_writer.yes")
            : t("profile.ai_writer.no")
        }`,
        addon_link: customer_plan.whitelabel_platform
          ? false
          : `https://buy.stripe.com/00w3cv4wi8Ik1DvgA90Fi1a?prefilled_email=${email}`,
      },
    ];
  }, [
    accUsage,
    userprojectlimit,
    userkeywordlimit,
    subuserinvitelimit,
    competitorslimit,
    keywordviewlimit,
    domainviewlimit,
    backlinkRowLmt,
    userRowLmt,
    refDomain,
    customer_plan,
    pdf_editable,
    t,
  ]);

  const redmee_code_show = false;

  return (
    <>
      {plan_loaded ? (
        <main className="profile-det profile-container">
          <div className="row g-4 account-details">
            <div className="col-12 col-md-12 col-xl-12">
              <div className="ProfileBox user-details">
                <div className="d-flex gap-4">
                  <Avtar user_name={userName} size={"60px"} />
                  <div className="profile-next-line">
                    <ul className="pr-contact-de">
                      <li style={{ color: "#2B2B2B" }} className="mt-0">
                        <b>{userName}</b>
                      </li>
                      <li
                        className="d-flex gap-1 align-items-center mb-1 flex-wrap"
                        style={{ color: "#2B2B2B" }}
                      >
                        <span
                          style={{
                            color: "#6C6E79",
                          }}
                        >
                          Email Id :
                        </span>
                        <span className="font-light-bold">{email}</span>
                      </li>
                      <li
                        className="d-flex gap-1 mb-1"
                        style={{ color: "#2B2B2B" }}
                      >
                        <span style={{ color: "#6C6E79" }}>Password : </span>
                        <span>**********</span>
                      </li>
                    </ul>
                    <button
                      className="Pr-btn"
                      style={{ minWidth: "120px" }}
                      onClick={() => setdeleteAlert(true)}
                    >
                      <Delete sx={{ paddingRight: "1px" }} />{" "}
                      {t("common_buttons.acc_delete")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-12 col-xl-12">
              <div className="user-plan-details h-100">
                <div className="ProfileBox plan-details flex-column h-100">
                  <div className="w-100">
                    <h2 className="profile-heading mb-2">
                      {t("profile.plan")}
                    </h2>
                    {customer_plan?.plan_name === "admin" ||
                    customer_plan?.length === 0 ? (
                      <div className="no_plan">
                        <img src={noPlanImg} alt="no plan" />
                      </div>
                    ) : customer_plan ? (
                      <div className="plan-detail-card">
                        <div className="pan-det">
                          {plan_loaded && (
                            <div className="card-plan-over">
                              {t("profile.active")}
                            </div>
                          )}
                          <div className="plan-price">
                            {customer_plan?.referral_user ? (
                              <span className="heading-large">
                                {customer_plan.plan_name}
                              </span>
                            ) : (
                              <>
                                <span>${customer_plan.price}</span> USD/
                                {customer_plan?.interval || "month"}
                              </>
                            )}
                          </div>

                          <ul className="referral-plan" type="dice">
                            {plan_feature?.map((feature) => {
                              return (
                                <li key={feature}>
                                  <CircleIcon
                                    sx={{
                                      fontSize: "8px",
                                    }}
                                    className="me-2"
                                  />
                                  {feature}
                                </li>
                              );
                            })}
                          </ul>

                          {user_type === "individual" ? (
                            <div className="d-flex align-items-center w-100 my-1">
                              <Link to="/upgrade" className="w-100">
                                <button
                                  style={{
                                    height: "40px",
                                    borderRadius: "5px",
                                  }}
                                  className={
                                    customer_plan?.validity === "ultimate"
                                      ? "upgrade-btn  m-0 px-2 py-1"
                                      : "upgrade-btn  m-0 px-2 py-1"
                                  }
                                >
                                  {customer_plan?.validity === "ultimate"
                                    ? t("profile.selected_button")
                                    : t("profile.upgrade_button")}
                                </button>
                              </Link>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    ) : user_type === "individual" ? (
                      <div className=" w-100">
                        <div className="pt-3">
                          <p className="mb-0">
                            {t("profile.alert_msg.not_have_any_plan")}
                          </p>
                          <p>{t("profile.alert_msg.buy_plan")}</p>
                        </div>
                        <Link to="/upgrade">
                          <button
                            className="upgrade-plan-btn mt-2"
                            style={{ height: "40px", minWidth: "100px" }}
                          >
                            {t("profile.alert_msg.upgrade")}
                          </button>
                        </Link>
                      </div>
                    ) : (
                      <div className=" w-100">
                        <div className="pt-3">
                          <h6 className="mb-0" style={{ color: "red" }}>
                            <p className="mb-0">
                              {t("profile.alert_msg.want_to_upgrade_plan")}
                            </p>
                            <p>{t("profile.alert_msg.contact_organization")}</p>
                          </h6>
                        </div>
                      </div>
                    )}
                  </div>

                  {!invited_user ? (
                    <div className="d-flex flex-column align-items-cnter w-100">
                      <p
                        className="msg-error text-start mb-0"
                        style={{ color: "red" }}
                      >
                        {t("profile.alert_msg.changr_plan")} -{" "}
                      </p>
                      <span style={{ color: "black" }}>{adminMail}</span>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="col-12 col-md-12 col-xl-12">
              <div className="ProfileBox email-notify">
                <div className="w-100">
                  <h2 className="profile-heading mb-2">
                    {t("profile.manage_subscription")}
                  </h2>
                  <div className="d-flex align-items-center flex-wrap gap-2">
                    <h4 className="mb-0 me-3">Need to make changes?</h4>
                    <div className="profile-update-ope">
                      <button
                        onClick={() => setCancelPlan(true)}
                        className="pr-buy-btn px-2"
                      >
                        {t("profile.manage_subscription")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-12 col-md-12 col-xl-12"
              style={{ display: "flex", gap: "20px" }}
            >
              {redmee_code_show ? (
                <div className="ProfileBox redeem-codes">
                  <div className="w-100">
                    <h2 className="profile-heading">
                      {t("profile.alert_msg.redeem_code.title")}
                      <ToolTip
                        title={t("profile.alert_msg.redeem_code.tooltip")}
                      />
                    </h2>

                    <form>
                      <div className="prefix_Form inviteForm mt-4">
                        <div className="d-flex align-items-center mb-3 flex-wrap gap-2">
                          {codeValidJsonStringParsedArray?.length >= 6 ||
                          !invited_user ? (
                            <div className="w-100 pe-0 d-flex align-items-center gap-2">
                              <input
                                type="text"
                                placeholder={t(
                                  "profile.form.referral_code.placeholder"
                                )}
                                value={
                                  !invited_user
                                    ? "You cannot redeem codes"
                                    : "all code used"
                                }
                                disabled
                              />
                              <Tooltip
                                title={
                                  !invited_user
                                    ? t("profile.form.referral_code.tooltip_1")
                                    : t("profile.form.referral_code.tooltip_2")
                                }
                                icon={
                                  <WarningAmberIcon
                                    sx={{ color: "#e95655" }}
                                    className="ms-0"
                                    fontSize="small"
                                  />
                                }
                              />
                            </div>
                          ) : (
                            <input
                              type="text"
                              placeholder={t(
                                "profile.form.placeholder_enter_code"
                              )}
                              value={referralCode}
                              onChange={handleChange}
                              className="w-50"
                            />
                          )}

                          <button
                            className="Pr-btn mt-0"
                            disabled={
                              validReferalCode?.referral_code_1 === "" &&
                              validReferalCode?.referral_code_2 === "" &&
                              validReferalCode?.referral_code_3 === "" &&
                              validReferalCode?.referral_code_4 === "" &&
                              validReferalCode?.referral_code_5 === "" &&
                              validReferalCode?.referral_code_6 === ""
                            }
                            onClick={(e) => ReferalHandler_Submit(e)}
                          >
                            {t("common_buttons.submit")}
                          </button>
                        </div>
                        {refAlert === "Matched" ? (
                          <p className="vl-msd-line text-start">
                            <span className="text-success">{refAlert} </span>
                          </p>
                        ) : (
                          <p className="vl-msd-line text-start">{refAlert}</p>
                        )}
                        {!invited_user ? (
                          <div className="d-flex flex-column align-items-cnter mt-4">
                            <p className="msg-error text-start mb-0">
                              {t("profile.alert_msg.cannot_redeem_any_codes")}-{" "}
                            </p>
                            <span style={{ color: "black" }}>{adminMail}</span>
                          </div>
                        ) : (
                          <div className="profile-next-line mt-4">
                            <h6
                              style={{ color: "#E95757" }}
                              className="font-light-bold"
                            >
                              {t("profile.instructions.title")}{" "}
                            </h6>{" "}
                            <h6 className="">
                              {t("profile.instructions.line_1")}
                            </h6>
                            <h6 className="mb-0">
                              {t("profile.instructions.line_2")}
                            </h6>
                          </div>
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              ) : (
                <>
                  <div className="ProfileBox email-notify">
                    <div className="w-100">
                      <h2 className="profile-heading mb-2">
                        {t("profile.email_notification")}
                      </h2>
                      <div className="d-flex align-items-center flex-wrap gap-2">
                        <Switch
                          className="react-switch"
                          onColor="#3183FF"
                          onChange={(e) => SubscribeHandler()}
                          checked={checkMailSub}
                          aria-labelledby="neat-label"
                          uncheckedIcon={false}
                          checkedIcon={false}
                          width={40}
                          height={20}
                        />
                        <h4 className="mb-0 me-3">
                          {t("profile.ranking_updates")}
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div className="ProfileBox add-user">
                    <SubUserDetails />
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="row g-4 account-plan">
            <div className="col-12">
              <Box
                className="h-100"
                sx={{
                  border: "1px solid rgba(0, 0, 0, 0.2)",
                  backgroundColor: "white",
                  borderRadius: "5px",
                  padding: "15px",
                }}
              >
                <h2 className="profile-heading">
                  {t("profile.account_usage.title")}
                </h2>

                <Box className="account-use">
                  {loading ? (
                    <div
                      className="h-100 d-flex align-items-center"
                      style={{ minHeight: "200px" }}
                    >
                      <Spinner />
                    </div>
                  ) : error ? (
                    <div style={{ height: "200px" }}>
                      <p className="text-center msg-error">
                        {t("profile.account_usage.failed_error")}
                      </p>
                    </div>
                  ) : (
                    <>
                      {userAccountUsage?.map((plan_usage) => {
                        return (
                          <Box
                            className="user-acc-list"
                            key={plan_usage.label}
                            style={{
                              padding: redmee_code_show ? "4px 0px" : "7px 0px",
                            }}
                          >
                            <div className="d-flex align-items-center justify-content-between w-100">
                              <span className="acc-usage-label">
                                {plan_usage?.label}{" "}
                              </span>
                              <span className="acc-usage-value">
                                {plan_usage.value}
                              </span>
                            </div>

                            {customer_plan?.length === 0 ||
                            customer_plan?.plan_name === "Free" ? null : (
                              <Box
                                className="d-flex justify-content-end align-items-center"
                                sx={{ minWidth: "fit-content" }}
                              >
                                <button
                                  disabled={!plan_usage.addon_link}
                                  className="ms-auto  pr-buy-btn"
                                  onClick={() =>
                                    handleAddonPlan(plan_usage?.addon_link)
                                  }
                                >
                                  {t("profile.buy_addon")}
                                </button>
                              </Box>
                            )}
                          </Box>
                        );
                      })}

                      <Box
                        className="user-acc-list"
                        key={"AI Writer"}
                        style={{
                          padding: redmee_code_show ? "4px 0px" : "7px 0px",
                        }}
                      >
                        <div className="d-flex align-items-center justify-content-between w-100">
                          <span className="acc-usage-label">
                            {t("profile.ai_writer.title")}
                          </span>
                          {customer_plan?.length === 0 ? (
                            <span className="acc-usage-value">
                              {t("profile.ai_writer.no")}
                            </span>
                          ) : ai_plan?.plan_name === "Free" ? (
                            <span className="acc-usage-value">
                              {aiLimit?.article || 0}/{ai_plan?.article}{" "}
                              {t("profile.ai_writer.blogs")}{" "}
                              {aiLimit?.meta || 0}/{ai_plan?.meta}{" "}
                              {t("profile.ai_writer.meta")}
                            </span>
                          ) : (
                            <span className="acc-usage-value">
                              {aiLimit?.limit || 0}/{ai_plan?.limit}
                              {t("profile.ai_writer.word_limit")}
                            </span>
                          )}
                        </div>

                        {customer_plan?.length === 0 ||
                        customer_plan?.plan_name === "Free" ? null : (
                          <Box
                            className="d-flex flex-wrap align-items-center"
                            sx={{ minWidth: "fit-content" }}
                          >
                            <Link to={"/ai/pricing"} className="ms-auto">
                              <button className="ms-auto pr-buy-btn">
                                {t("profile.buy_addon")}
                              </button>
                            </Link>
                          </Box>
                        )}
                      </Box>
                    </>
                  )}
                </Box>
              </Box>
            </div>
            {redmee_code_show ? (
              <div className="col-12" style={{ display: "flex", gap: "20px" }}>
                <div className="ProfileBox email-notify">
                  <div className="w-100">
                    <h2 className="profile-heading mb-2">
                      {t("profile.email_notification")}
                    </h2>
                    <div className="d-flex align-items-center flex-wrap gap-2">
                      <Switch
                        className="react-switch"
                        onColor="#3183FF"
                        onChange={(e) => SubscribeHandler()}
                        checked={checkMailSub}
                        aria-labelledby="neat-label"
                        uncheckedIcon={false}
                        checkedIcon={false}
                        width={40}
                        height={20}
                      />
                      <h4 className="mb-0 me-3">
                        {t("profile.ranking_updates")}
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="ProfileBox add-user">
                  <SubUserDetails />
                </div>
              </div>
            ) : null}
          </div>
          {cancelPlan && (
            <CancelPlanPopUp
              onClose={() => setCancelPlan(false)}
              {...{
                setCancelPlan,
                cancelPlan,
              }}
            />
          )}

          {deleteAlert ? (
            <AreYousure
              callback={User_Delete}
              title={t("profile.delete_alert")}
            />
          ) : null}
        </main>
      ) : (
        <FallbackLoader />
      )}
    </>
  );
};

export default Profile;
